<fieldset>
  <legend
    [class.editable-title]="isAllowedToEditTitle"
    (click)="onTitleClicked()"
  >
    {{ title }}
  </legend>

  <div class="card-details">
    <div class="col">
      <mat-form-field>
        <mat-label>File Name</mat-label>
        <input readonly matInput type="text" [value]="usedFileMeta?.fileName" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{
          placeholderFileState[usedFileMeta?.state || fileState.UPLOADED] +
            " On"
        }}</mat-label>
        <input readonly matInput type="text" [value]="changeDateTime" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{
          placeholderFileState[usedFileMeta?.state || fileState.UPLOADED] +
            " By"
        }}</mat-label>
        <input readonly matInput type="text" [value]="changeUserName" />
      </mat-form-field>

      <div class="row">
        <button
          mat-button
          type="button"
          class="btnNeutral"
          [disabled]="!usedFileMeta || usedFileMeta.state === fileState.DELETED"
          (click)="onDownloadClicked()"
        >
          Download
        </button>
        <button
          *ngIf="archivable"
          mat-button
          type="button"
          class="btnNegative"
          [disabled]="
            !isAllowedToArchive || usedFileMeta?.state !== fileState.UPLOADED
          "
          (click)="archive.emit()"
        >
          Archive
        </button>
        <button
          *ngIf="archiveOpenable"
          mat-button
          type="button"
          class="btnNeutral"
          [disabled]="!isAllowedToOpenArchive"
          (click)="openArchive.emit()"
        >
          Open Archive
        </button>
        <button
          *ngIf="deletable"
          mat-button
          type="button"
          class="btnNegative"
          [disabled]="
            !isAllowedToDelete ||
            !usedFileMeta ||
            usedFileMeta.state === fileState.DELETED
          "
          (click)="delete.emit()"
        >
          Delete
        </button>
        <a
          #downloadLink
          class="file-card-hidden"
          [download]="usedFileMeta?.fileName"
          >Download File</a
        >
      </div>
    </div>

    <div class="col">
      <mat-form-field>
        <mat-label>Upload File Name</mat-label>
        <input readonly matInput type="text" [value]="selectedFile?.name" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Upload File Type</mat-label>
        <input readonly matInput type="text" [value]="selectedFile?.type" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Upload File Size</mat-label>
        <input
          readonly
          matInput
          type="text"
          [value]="selectedFile ? selectedFile.size + ' bytes' : ''"
        />
      </mat-form-field>

      <div class="row flex-wrap">
        <button
          mat-button
          type="button"
          class="btnNeutral"
          [disabled]="!isAllowedToUpload"
          (click)="inputFile.click()"
        >
          Select File
        </button>
        <button
          mat-button
          type="button"
          class="btnPositive"
          [disabled]="
            !isAllowedToUpload ||
            !selectedFile ||
            selectedFileTypeInvalid ||
            selectedFileSizeInvalid ||
            disableUpload
          "
          (click)="upload.emit(selectedFile)"
        >
          Upload
        </button>
        <ng-content></ng-content>
        <input
          #inputFile
          type="file"
          class="file-card-hidden"
          (change)="onFileForUploadSelected($event)"
          [accept]="acceptedFileTypes"
        />
      </div>
      <div>
        <mat-error *ngIf="selectedFileTypeInvalid">
          Selected file is not of an accepted file type. Select a file with one
          of the following extensions: {{ acceptedFileTypes }}
        </mat-error>
        <mat-error *ngIf="selectedFileSizeInvalid"
          >Selected file exceeds maximum file size of 16MB.</mat-error
        >
      </div>
    </div>
  </div>

  <div>
    <table class="log-table">
      <tr *ngFor="let log of fileUploadLogs" [log]="log" digires-file-log></tr>
    </table>
  </div>
</fieldset>
